import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ConfigProvider } from '../../providers/config/config';
import * as _ from 'lodash';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ToolsProvider } from '../../providers/tools/tools';

@Component({
  selector: 'ad-videos',
  templateUrl: 'ad-videos.html',
})
export class AdVideosComponent {
  @Input() tripLocation;

  @Output() skipAdChange = new EventEmitter<boolean>();

  localTestVid: SafeResourceUrl;
  remainingSeconds;
  videoAdConfig;
  videoUrl;
  timer;

  constructor(
    public configs: ConfigProvider,
    private sanitizer: DomSanitizer,
    public tools: ToolsProvider
  ) {}

  ngOnInit() {
    this.videoAdConfig = this.configs.get('sponsorship-maps-interstitial');
    this.videoUrl =
      _.get(this.videoAdConfig, 'videoUrlLocal') ||
      _.get(this.videoAdConfig, 'videoUrl');

    if (
      !this.videoUrl ||
      localStorage.getItem('sponsorship-maps-interstitial-skip')
    ) {
      this.skipAdChange.emit(true);
    } else {
      // if (_.get(this.videoAdConfig, 'tags')) {
      //   const tags = this.videoAdConfig.tags;
      //   _.each(tags, scriptTag => this.addScript(scriptTag));
      // }
      setTimeout(() => {
        this.countdownTimer(_.get(this.videoAdConfig, 'skipTime') || 10);
      }, 1000);
      this.tools.logAnalyticsEvent(
        'trackCustom',
        'sponsorship-maps-interstitial'
      );
    }
  }

  addScript(sponsorshipTag: {
    src: string;
    attributes: [{ key: string; value: string }];
  }) {
    return new Promise((resolve, reject) => {
      const s = document.createElement('script');

      s.setAttribute('src', sponsorshipTag.src);
      _.each(sponsorshipTag.attributes, att => {
        if (_.get(att, 'value')) {
          s.setAttribute(att.key, att.value);
        } else {
          s.setAttribute(att.key, att.key);
        }
      });

      document.body.appendChild(s);
    });
  }

  addImageTag(src) {
    return new Promise((resolve, reject) => {
      const s = document.createElement('image');

      s.setAttribute('src', src);
      s.addEventListener('load', resolve);
      s.addEventListener('error', reject);

      document.body.appendChild(s);
    });
  }

  countdownTimer(seconds) {
    localStorage.setItem('sponsorship-maps-interstitial-skip', 'true');
    this.remainingSeconds = seconds;
    this.timer = setInterval(() => {
      if (this.remainingSeconds <= -3) {
        clearInterval(this.timer);
        this.skipAdChange.emit(true);
      } else {
        this.remainingSeconds--;
      }
    }, 1000);
  }

  skipAd() {
    this.skipAdChange.emit(true);
  }

  adLearnMore(e?) {
    e?.stopPropagation();
    const url = _.get(this, 'videoAdConfig.advertiser.url');
    this.tools.logAnalyticsEvent('trackCustom', 'sponsorship-maps-click', {
      url,
    });
    this.tools.openExternalUrl(url);
  }
}



// WEBPACK FOOTER //
// ./src/components/ad-videos/ad-videos.ts